import { render } from "./ListeTransfertMagasin.vue?vue&type=template&id=efbbb17c&ts=true"
import script from "./ListeTransfertMagasin.vue?vue&type=script&lang=ts"
export * from "./ListeTransfertMagasin.vue?vue&type=script&lang=ts"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__